// extracted by mini-css-extract-plugin
module.exports = {"conditions":"bd_fd","conditions__content":"bd_ff","conditions__footer":"bd_fg"};